import { boxShadows, colors } from '@insurancemenu/imenu-components-lib/dist/utils';
import StepCard from 'components/common/checklist/StepCard';
import styled from 'styled-components';

export const TaskStyled = styled.li<{ $isExpanded: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ $isExpanded }): string => ($isExpanded ? '2rem 3.2rem 3rem' : ' 2rem 3.2rem 2rem')};
  border-radius: 10px;
  box-shadow: ${boxShadows.light[4]};
  color: ${colors.neutral[900]};
  background-color: ${colors.neutral.white};
`;

export const TaskHeaderStyled = styled.div<{ $isExpanded: boolean; $isCollapsible: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8rem;
  width: 100%;
  padding: 0 0 ${({ $isExpanded }): string => ($isExpanded ? '2rem' : '0')};
  border: none;
  border-bottom: ${({ $isExpanded }): string => ($isExpanded ? `1px solid ${colors.neutral[300]}` : 'none')};
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: ${({ $isCollapsible }): string => ($isCollapsible ? 'pointer' : 'default')};

  svg {
    flex-shrink: 0;
  }
`;

export const TaskHeaderContentStyled = styled.div`
  display: flex;
  gap: 1rem;
  min-width: 0;
`;

export const TaskTitleBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const TaskTitleStyled = styled.h3`
  font-size: 2rem;
  line-height: 2.8rem;
  letter-spacing: 0.45px;
  word-break: break-word;
  margin: 0;
`;

export const TaskSubtitleStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0.32px;
  margin: 0;
  color: ${colors.neutral[700]};
`;

export const ChecklistStepsStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 3rem 0 0;
  gap: 1.5rem;
`;

export const StepCardStyled = styled(StepCard)`
  border: 1px solid ${colors.neutral[300]};
  border-radius: 10px;
  margin: 0;
`;
